import { Tooltip } from "antd";
import React from "react";
import { useNewTrialState } from "../../new-trail/hooks/NewTrialStateProvider";
import "../styles.less";
import { AUTOZONE_REQUEST_STATUS } from "../types";
type TooltipType = "processing" | "generation";

interface TooltipProps {
  type: TooltipType;
  children?: React.ReactNode;
}
const ZoneTooltip: React.FC<TooltipProps> = ({ type, children }) => {
  const { autozoneRequestStatus } = useNewTrialState();
  return autozoneRequestStatus === AUTOZONE_REQUEST_STATUS.DEFAULT ? (
    <GenerationToolTip>{children}</GenerationToolTip>
  ) : (
    <ProcessingTooltip>{children}</ProcessingTooltip>
  );
};

// const ZoneTooltip: React.FC<TooltipProps> = ({ type, children }) => {
//   const {autozoneRequestStatus} = useNewTrialState();
//   return type === "processing" ? (
//     <ProcessingTooltip>{children}</ProcessingTooltip>
//   ) : (
//     <GenerationToolTip>{children}</GenerationToolTip>
//   );
// };

export default ZoneTooltip;

const ProcessingTooltip: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Tooltip
      className="autozone-tooltip"
      placement="leftTop"
      title={
        "Processing images for this field is in progress. Once completed, you’ll be able to view the autozone layer and variability indexes"
      }
    >
      {children}
    </Tooltip>
  );
};

export const GenerationToolTip: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Tooltip
      className="autozone-tooltip"
      placement="leftTop"
      title={"Click to generate autozone layer"}
    >
      {children}
    </Tooltip>
  );
};
